import { render, staticRenderFns } from "./ItemDetails_Variants_Values.vue?vue&type=template&id=ede67126&"
import script from "./ItemDetails_Variants_Values.vue?vue&type=script&lang=js&"
export * from "./ItemDetails_Variants_Values.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports